import searchDepthItem from '../search-depth-item';

/**
 * Returns the action data
 *
 * @param {Number} itemID The item ID
 * @return {Object} The item
 */
const getItemAction = ( itemID ) => {
	return searchDepthItem(
		UncannyAutomator._recipe.actions.items,
		itemID
	);
}

export default getItemAction;
